import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { useRef } from 'react';
import AnimatedElement from '../..';
import { ChildrenPropType, ObjectPropsPropType } from '../../../../../../services/proptypes';
import { classNames } from '../../../../../../utils/classname';
import { HEIGHT_TRANSITION, ANIMATION_STATUS, DEFAULT_ANIMATION_DURATION } from '../../../../animation.constants';
import useFixedValueAnimation from '../../../../hooks/use-fixed-value-animation';
import FadeReveal from '../../../Reveal/variants/FadeReveal';
import './AnimateHeight.css';
var defaultProps = {
  children: null,
  content: null,
  duration: DEFAULT_ANIMATION_DURATION,
  easing: 'ease',
  height: 'auto',
  className: '',
  style: {},
  disableAnimation: false,
  fade: false
};
var PRE_ANIMATING = ANIMATION_STATUS.PRE_ANIMATING,
  ANIMATING = ANIMATION_STATUS.ANIMATING,
  NO_ANIMATION = ANIMATION_STATUS.NO_ANIMATION,
  SERVER_SIDE = ANIMATION_STATUS.SERVER_SIDE;
export default function AnimateHeight(_ref) {
  var _ref2;
  var children = _ref.children,
    content = _ref.content,
    className = _ref.className,
    style = _ref.style,
    duration = _ref.duration,
    easing = _ref.easing,
    height = _ref.height,
    disableAnimation = _ref.disableAnimation,
    fade = _ref.fade;
  var contentRef = useRef(null);
  var _useFixedValueAnimati = useFixedValueAnimation(height, contentRef, HEIGHT_TRANSITION, {
      duration: duration
    }),
    currentHeight = _useFixedValueAnimati.currentValue,
    overflow = _useFixedValueAnimati.overflow,
    state = _useFixedValueAnimati.state;
  var status = state.status;
  var finalClassName = classNames(_defineProperty({
    'animate-height': true
  }, className, true));
  var finalChildren = content || children;
  return /*#__PURE__*/React.createElement(AnimatedElement, {
    status: status,
    transitionType: HEIGHT_TRANSITION,
    transitionProps: (_ref2 = {}, _defineProperty(_ref2, SERVER_SIDE, {
      height: currentHeight,
      overflow: style.overflow || overflow
    }), _defineProperty(_ref2, PRE_ANIMATING, {
      height: currentHeight,
      overflow: style.overflow || overflow
    }), _defineProperty(_ref2, ANIMATING, {
      height: currentHeight,
      overflow: overflow
    }), _defineProperty(_ref2, NO_ANIMATION, {
      height: currentHeight,
      overflow: style.overflow || overflow
    }), _ref2),
    duration: disableAnimation ? 0 : duration,
    easing: easing,
    wrap: true,
    className: finalClassName
  }, /*#__PURE__*/React.createElement("div", {
    ref: contentRef
  }, fade ? /*#__PURE__*/React.createElement(FadeReveal, {
    duration: duration * 2,
    disableAnimation: disableAnimation
  }, finalChildren) : finalChildren));
}
AnimateHeight.defaultProps = defaultProps;